import { render, staticRenderFns } from "./SalaryDefaultUpdate.vue?vue&type=template&id=97261d7a&scoped=true"
import script from "./SalaryDefaultUpdate.vue?vue&type=script&lang=js"
export * from "./SalaryDefaultUpdate.vue?vue&type=script&lang=js"
import style0 from "./SalaryDefaultUpdate.vue?vue&type=style&index=0&id=97261d7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97261d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97261d7a')) {
      api.createRecord('97261d7a', component.options)
    } else {
      api.reload('97261d7a', component.options)
    }
    module.hot.accept("./SalaryDefaultUpdate.vue?vue&type=template&id=97261d7a&scoped=true", function () {
      api.rerender('97261d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryDefaultUpdate.vue"
export default component.exports